import { useQAPairMeta, useQAPairOpened, useQAPairVisible } from 'hooks/business/im/useQAPair';
import { useMemo } from 'react';
import { RelateModal } from './RelateModal';
import { isIdEqual } from 'utils/is';

interface QAPairProps {
  containerRef: React.RefObject<HTMLDivElement>;
  conversation: Conversation.Conversation;
}

export const QAPair = (props: QAPairProps) => {
  const { conversation, containerRef } = props;
  const qaPairOpened = useQAPairOpened();

  const qaPairMeta = useQAPairMeta();
  const qaPairVisible = useQAPairVisible();
  const { defaultKnowledgeQueryMessage } = qaPairMeta;

  const qaPairEnable = useMemo(() => {
    const hasKnowledgeQuery = !!defaultKnowledgeQueryMessage?.msgId;
    const qaConversationId = defaultKnowledgeQueryMessage?.conversationId;
    const isSameConversation = isIdEqual(qaConversationId, conversation.conversationId);
    return (
      qaPairOpened && !!conversation && hasKnowledgeQuery && qaPairVisible && isSameConversation
    );
  }, [qaPairOpened, conversation, qaPairVisible, defaultKnowledgeQueryMessage]);

  if (qaPairEnable) {
    return (
      <RelateModal
        key={conversation.conversationId}
        knowledgeQuery={defaultKnowledgeQueryMessage!}
        visible={qaPairEnable}
        conversation={conversation!}
        selectable
        containerRef={containerRef}
      />
    );
  }

  return null;
};
